/// \file notificationSubscriptions.tsx
///
/// \par Copyright Notice:
/// Copyright (c) 2023 by Oshkosh Corporation.
/// All Rights Reserved.
///
/// \par
/// The information contained herein is confidential and proprietary property
/// of Oshkosh Corporation, and may be privileged.  The dissemination,
/// distribution, use, copying, transfer, or disclosure of such information is
/// strictly prohibited except by express written agreement with Oshkosh
/// Corporation, or with one of its subsidiaries.

import {lazy, Suspense} from "react";
import { ActionFunctionArgs, LoaderFunctionArgs, Route } from "react-router-dom";

const NotificationSubscriptionList = lazy(() => import('../views/notification-subscriptions/list/view'));

async function notificationSubscriptionDataLoader(args: LoaderFunctionArgs) {
  const actualLoader = (await import('../views/notification-subscriptions/list/loader')).default;
  return actualLoader(args);
}

export async function notificationSubscriptionAction(args: ActionFunctionArgs) {
  const actualAction = (await import("../views/notification-subscriptions/list/action")).action;
  return actualAction(args);
}

const routes = (
  <Route
    path="notificationSubscription"
    handle={{
      text:"NOTIFICATION SUBSCRIPTIONS"
    }}
  >
    <Route
      index
      element={
        <Suspense fallback={<div>Loading...</div>}>
          <NotificationSubscriptionList />
        </Suspense>
      }
      loader={notificationSubscriptionDataLoader}
      action={notificationSubscriptionAction}
      />
  </Route>
);

export default routes;